<template>
  <div class="ll-paginate">
    <paginate
      :value="value"
      :page-count="pageCount"
      :page-range="pageRange"
      :margin-pages="marginPages"
      :first-button-text="_paginationFirstButtonText"
      :last-button-text="_paginationLastButtonText"
      :prev-text="_paginationPrevText"
      :next-text="_paginationNextText"
      :container-class="'pagination'"
      first-last-button
      @input="$emit('input',$event)"
    />
  </div>
</template>
<script>
export default {
  name: "LlPaginate",
  props: {
    pageCount: {
      type: Number,
      default: 0,
    },
    value: {
      type: Number,
      default: 0,
    },
    pageRange: {
      type: Number,
      default: 3,
    },
    marginPages: {
      type: Number,
      default: 3,
    },
  },
  computed: {
    _paginationPrevText() {
      return '<i class="icon-chevron-back" />';
    },
    _paginationNextText() {
      return '<i class="icon-chevron-forward" />';
    },
    _paginationFirstButtonText() {
      return '<i class="icon-chevron-back-start" />';
    },
    _paginationLastButtonText() {
      return '<i class="icon-chevron-forward-end" />';
    },
  },
};
</script>
<style lang="scss" scoped>
</style>